import { useEffect, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppFooter } from "../../components/main-components/footer";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { getAllLectureNotes, loadAllUsers  } from "../../services/documents/documents.context";
import { Usersdata } from "../../components/cards/users-data";
import { Lecturedata } from "../../components/cards/lecture-notes.data";
import { Loader } from "../../components/utilities/loader";
import { Projectdata } from "../../components/cards/project.data";
import { Ebookdata } from "../../components/cards/ebook.data";
import { PastQuestionData } from "../../components/cards/past-question.data";
import { Questionsdata } from "../../components/cards/questions.card";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons/faCaretLeft";
import { useAuth } from "../../services/authentication/authentication.context";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { DashboardData } from "../../components/dashboard/dash-ctrl";


import "../../styles/dashboard.css";
import "../../styles/dashboard-data.css";
import "../../styles/alert.css";
import { AppAlert } from "../../components/utilities/alert";



export const Dashboard = () => {

    const { hSubscribers, tSubscribers, token } = useAuth();

    const [itesmCnt, setItemsCnt] = useState({
        notesCount: 0,
        projectsCount: 0,
        ebooksCount: 0,
        questionsCount: 0,
        videosCount: 0,
        usersCount: 0
    })

    const [notes, setNotes] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [onAlert, setOnAlert] = useState();


    const [chosen, setChosen] = useState("users");
    const [pageNum, setPageNum] = useState(1);


    // const { token } = useAuth();

    const paginateData = (page, data) => {
        const pageData = data?.slice((page - 1) * 10, ((page - 1) * 10) + 10);
        return pageData;
    }



    useEffect(() => {
        (async () => {
            setLoading(true);
            /** all users */
            if (token) {
                const allUsers = await loadAllUsers(token);
                setItemsCnt((cnt) => ({ ...cnt, usersCount: allUsers?.length }))
                setUsers(paginateData(pageNum, allUsers));

                console.log(allUsers);
            }



            /** all lecture notes */
            const allNotes = await getAllLectureNotes();
            setItemsCnt((cnt) => ({ ...cnt, notesCount: allNotes?.length }))
            setNotes(paginateData(pageNum, allNotes));

            /** past question subscribers */
            setItemsCnt((cnt) => ({ ...cnt, hndSubs: hSubscribers?.length }));

            /** tutorial subscriers */
            setItemsCnt((cnt) => ({ ...cnt, tutSubs: tSubscribers?.length }));

            setLoading(false);
        })();
    }, [pageNum, hSubscribers, tSubscribers, token]);




    return (
        <div>
            <BmsHeader />
            <SkewBox title={"Dashboard"} background={"/media/dashboard.png"} />
            {(loading) && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    close={() => setOnAlert()}
                    acceptAction={() => setOnAlert()}
                />
            )}
            <div className="notes-page">
                <div className="main-page">
                    <div className="search-caption">Dashboard</div>
                    <div className="dashboard">
                        <DashboardData data={itesmCnt} />
                    </div>

                    <div className="dash-data">
                        <div className="nav-tabs">
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "users" },
                                    { "users": chosen !== "users" }
                                )}
                                onClick={() => {
                                    setChosen("users");
                                    setPageNum(1);
                                }}
                            >
                                Users
                            </button>
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "notes" },
                                    { "notes": chosen !== "notes" }
                                )}
                                onClick={() => {
                                    setChosen("notes");
                                    setPageNum(1);
                                }}
                            >
                                Notes
                            </button>
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "project" },
                                    { "proj-btn": chosen !== "project" }
                                )}
                                onClick={() => {
                                    setChosen("project");
                                    setPageNum(1);
                                }}
                            >
                                Tutorials Subscr.
                            </button>
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "resources" },
                                    { "resources-btn": chosen !== "resources" }
                                )}
                                onClick={() => {
                                    setChosen("resources");
                                    setPageNum(1);
                                }}
                            >
                                HND Subscr.
                            </button>
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "HND_past_questions" },
                                    { "jobs-btn": chosen !== "HND_past_questions" }
                                )}
                                onClick={() => {
                                    setChosen("HND_past_questions");
                                    setPageNum(1);
                                }}
                            >
                                HND Past Q.
                            </button>
                            <button
                                className={classNames(
                                    { "tab-btn": true },
                                    { "chosen": chosen === "Tutorials" },
                                    { "qa-btn": chosen !== "Tutorials" }
                                )}
                                onClick={() => {
                                    setChosen("Tutorials");
                                    setPageNum(1);
                                }}
                            >
                                Tutorials
                            </button>
                        </div>
                        {chosen === "users" && <Usersdata data={users} />}
                        {chosen === "notes" && <Lecturedata data={notes} />}
                        {chosen === "project" && <Projectdata data={tSubscribers} />}
                        {chosen === "resources" && <Ebookdata data={hSubscribers} />}
                        {chosen === "HND_past_questions" && <PastQuestionData  />}
                        {chosen === "Tutorials" && <Questionsdata />}
                    </div>


                    <div className="page-button-container">
                        <button
                            className={classNames("page-button", { "disabled": pageNum === 1 })}
                            onClick={() => setPageNum((p) => p - 1)}
                            disabled={pageNum === 1}
                        >
                            <FontAwesomeIcon icon={faCaretLeft} className="page-icon" />
                            Prev
                        </button>
                        <span className="page-label">{pageNum}</span>
                        <button
                            className="page-button"
                            onClick={() => setPageNum((p) => p + 1)}
                        >
                            Next
                            <FontAwesomeIcon icon={faCaretRight} className="page-icon" />
                        </button>
                    </div>
                </div>
                
            </div>
            <AppFooter />
        </div>
    );
}